import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import HelpAndSupportPage from '../../../src/client/pages/insurance/help-and-support-greenstone';

export const getStaticPaths = () => getStaticPathsForInsuranceTypes([INSURANCE_TYPES.LIFE]);

export const getStaticProps = () => ({
  props: {
    insuranceType: INSURANCE_TYPES.LIFE,
  },
});

export default HelpAndSupportPage;
